import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../../hooks/useFetch";

const HAFHPhotos = ({ t, role, hostelCode }) => {

  const authState = useSelector((state) => state.authReducer);
  const [fetchData] = useFetch();

  const [photos, setPhotos] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("ALL");

  const roleFilters = [
    "STUDENT",
    "PARENT",
    "OWNER",
    "MANAGER",
    "INSTITUTION",
    "ADMIN",
    "MESS",
    "TRANSPORTER",
    "DIRECTOR",
  ];

  const filtered =
    selectedFilter === "ALL"
      ? photos
      : photos.filter(
          (p) => p.uploaderRole === selectedFilter
        );

  const fetchPhotos = async () => {
    try {
      const res = await fetchData({
        url: "/hafh/communication/photos/all",
        method: "post",
        data: { hostelCode },
        headers: {
          Authorization: authState.token,
        },
      });
      if (res?.status) {
        setPhotos(res.records || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (hostelCode) {
      fetchPhotos();
    }
  }, [hostelCode]);

  return (
    <div className="bg-gray-900 p-5 rounded-xl text-white space-y-4">
      <h2 className="text-cyan-300 text-lg font-bold">
        📸 Hostel Photos Gallery
      </h2>

      <div className="grid grid-cols-3 lg:grid-cols-5 gap-1">
        <button
          onClick={() => setSelectedFilter("ALL")}
          className={`px-3 py-2 rounded-md text-xs ${
            selectedFilter === "ALL"
              ? "bg-teal-600"
              : "bg-gray-700"
          }`}
        >
          ALL
        </button>

        {roleFilters.map((f) => (
          <button
            key={f}
            onClick={() => setSelectedFilter(f)}
            className={`px-3 py-2 rounded-md text-xs ${
              selectedFilter === f
                ? "bg-teal-600"
                : "bg-gray-700"
            }`}
          >
            {f}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {filtered.length === 0 ? (
          <div className="text-gray-400 text-sm">
            No photos found
          </div>
        ) : (
          filtered.map((p) => (
            <div
              key={p._id}
              className="bg-gray-800 rounded-xl overflow-hidden border border-gray-700"
            >
              <div className="h-56 bg-gray-900">
                <img
                  src={p.url}
                  alt={p.caption || "photo"}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="p-4 space-y-2">
                <div className="text-sm text-gray-200 font-medium">
                  {p.caption || "No caption"}
                </div>

                <div className="text-xs text-cyan-300">
                  Visibility: {p.visibility || "PRIVATE"}
                </div>
                <div className="text-xs text-gray-400">
                  Uploaded By: {p.userName || "Unknown"}
                </div>
                <div className="text-xs text-gray-500">
                  {p.createdAt
                    ? new Date(p.createdAt).toLocaleString()
                    : ""}
                </div>

                {p.tags?.length > 0 && (
                  <div className="flex flex-wrap gap-1 mt-2">
                    {p.tags.map((tag, i) => (
                      <span
                        key={i}
                        className="text-xs bg-gray-700 px-2 py-1 rounded"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                )}

                <div className="flex flex-wrap gap-2 text-xs">
                  {p.isPinned && (
                    <div className="text-yellow-300">
                      📌 Pinned
                    </div>
                  )}

                  {p.isActive && (
                    <div className="text-green-300">
                      ✅ Active
                    </div>
                  )}
                </div>

                {/* ACTIONS */}
                <div className="flex gap-2 mt-3">
                  <button className="px-3 py-1 bg-blue-600 text-xs rounded">
                    View
                  </button>
                  <button className="px-3 py-1 bg-green-600 text-xs rounded">
                    Edit
                  </button>
                  <button className="px-3 py-1 bg-red-600 text-xs rounded">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default HAFHPhotos;